var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Hero',{attrs:{"title":"Fatores","message":"Fatores de exclusão/cálculo disponíveis para criação de modelos de análise e scheduling","icon":"mdi-table","action":"withoutAction","layout_type":"rails"}}),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TableFactors')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }